import { RefObject } from 'react';
import { ClearIndicatorProps } from 'react-select';
import { SelectOption } from '../../types';
import { DropdownActionStyle } from '@ardoq/dropdown-menu-ui';
import styled from 'styled-components';
import { s8 } from '@ardoq/design-tokens';
import { t } from '@ardoq/i18n';
import { getI18nLocaleFromSelectProps } from './getI18nLocaleFromSelectProps';

const ClearIndicatorStyle = styled(DropdownActionStyle)`
  margin-right: ${s8};
`;

export const ClearIndicator = (
  props: ClearIndicatorProps<SelectOption<unknown>>
) => {
  const {
    innerProps: { ref, ...restInnerProps },
    selectProps,
  } = props;
  const ariaLabelContext = selectProps['aria-label'] as string | undefined;
  const i18nLocale = getI18nLocaleFromSelectProps(selectProps);
  const ariaLabel = ariaLabelContext
    ? t(
        i18nLocale,
        'select:clearLabeled',
        { label: ariaLabelContext },
        'Clear {{label}}'
      )
    : t(i18nLocale, 'select:clearAll', 'Clear all selections');
  return (
    <ClearIndicatorStyle
      {...restInnerProps}
      ref={ref as RefObject<HTMLDivElement>}
      role="button"
      data-test-id={'clear-all'}
      aria-label={ariaLabel}
      /** For some reason, react-select sets aria-hidden to true. This is not ideal for accessibility, so remove it here. */
      aria-hidden={undefined}
    >
      {t(i18nLocale, 'select:clear', 'Clear')}
    </ClearIndicatorStyle>
  );
};
